import React from "react";
import style from "./IndustrySlideShow.module.css";
import OurIndustryCard from "../../components/OurIndustryCard/index.jsx";

import img1 from "../../assets/OurIndustry folder/img1.png";
import img2 from "../../assets/OurIndustry folder/img2.png";
import img3 from "../../assets/OurIndustry folder/img3.png";
import img4 from "../../assets/OurIndustry folder/img4.png";
import img5 from "../../assets/OurIndustry folder/img5.png";
import img6 from "../../assets/OurIndustry folder/img6.png";
import img8 from "../../assets/OurIndustry folder/img8.png";
import img9 from "../../assets/OurIndustry folder/img9.png";
import img10 from "../../assets/OurIndustry folder/img10.png";
import img11 from "../../assets/OurIndustry folder/img11.png";
import img12 from "../../assets/OurIndustry folder/img12.png";

export default function IndustrySlideShow() {

    const cardArray = [
        {
            imgSrc: img1,
            text: "Banking & Financial Services"
        },
        {
            imgSrc: img2,
            text: "Manufacturing & Engineering"
        },
        {
            imgSrc: img3,
            text: "Energy & Utilities"
        },
        {
            imgSrc: img4,
            text: "Logistics & Transportation"
        },
        {
            imgSrc: img5,
            text: "Education & EdTech"
        },
        {
            imgSrc: img6,
            text: "Healthcare & Life Sciences"
        },
        {
            imgSrc: img8,
            text: "Retail & E-Commerce"
        },
        {
            imgSrc: img9,
            text: "Media & Entertainment"
        },
        {
            imgSrc: img10,
            text: "Telecom & Communication"
        },
        {
            imgSrc: img11,
            text: "Automotive & Mobility"
        },
        {
            imgSrc: img12,
            text: "Real Estate & Construction"
        }
    ];

    return(

        <div className={style.OurIndustries_outer}>
            <div className={style.OurIndustries_content}>
                <p>Powering Growth Across Industries!</p>
                <p>From tech to travel, healthcare to finance – our expertise spans the industries shaping the future.</p>
            </div>
            <br />
            
            {/* Slide-show logic */}
            <div className="sliding_window" style={{display: "flex", overflowX: 'hidden'}}>
                <div className={style.OurIndustries_container}>
                    {
                        cardArray.map((Card, index) => {
                            return <OurIndustryCard imgSrc={Card.imgSrc} text={Card.text} />
                        })
                    }
                </div>
                <div className={style.OurIndustries_container}>
                    {
                        cardArray.map((Card, index) => {
                            return <OurIndustryCard imgSrc={Card.imgSrc} text={Card.text} />
                        })
                    }
                </div>
            </div>
        </div>
    );
}